import { useEffect, useState } from 'react';

/**
 * True when the viewport is too narrow for a pinned sidebar.
 *
 * `useInputMode` answers "is this a touch device", which is not the same
 * question: a manager on a mouse-driven tablet, or anyone with a half-width
 * browser window, reports `pointer: fine` and used to get the full 256px
 * pinned sidebar inside a 390px viewport — which shoved every page off the
 * right edge. Drawer mode is driven by BOTH signals: touch OR narrow.
 */
const QUERY = '(max-width: 767px)';

export function useIsNarrow() {
  const get = () => {
    if (typeof window === 'undefined') return false;
    try { return window.matchMedia(QUERY).matches; } catch { return false; }
  };
  const [narrow, setNarrow] = useState(get);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let mq;
    try { mq = window.matchMedia(QUERY); } catch { return; }
    const onChange = (e) => setNarrow(e.matches);
    // Safari < 14 only has the deprecated listener API.
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    setNarrow(mq.matches);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return narrow;
}

export default useIsNarrow;
